import React, { useState } from "react";
import AssignMemory from "../../smart/buttonPopups/AssignMemory";
import CreateMemory from "../../smart/buttonPopups/CreateMemory";
import SetMemoryPenalty from "../../smart/buttonPopups/SetMemoryPenalty";
import SetMemoryWrite from "../../smart/buttonPopups/SetMemoryWrite";
import UnassignMemory from "../../smart/buttonPopups/UnassignMemory";
import { Table } from "../DataTable";

const Memories = props => {

    const memoryURL = props.memoryURL ? props.memoryURL : "/PM/memory/view/:memoryID";

    const hidePenalty = props.titleID == undefined && props.projectID == undefined && props.taskID == undefined;
    const hideWrite = props.titleID == undefined && props.projectID == undefined && props.taskID == undefined;

    const [checkValues, setCheckValues] = useState([]);

    const renderRow = (row, renderData) =>
        <React.Fragment>
            {renderData(row.ID, { key: "id" })}
            {renderData(row.name, { key: "name", here: memoryURL.replace(":memoryID", row.ID) })}
            {renderData(row.note, { key: "note" })}
            {renderData(row.sourceLang, { key: "sourcelang" })}
            {renderData(row.penalty, { key: "penalty", hidden: hidePenalty })}
            {renderData(row.write, { key: "write", hidden: hideWrite })}
        </React.Fragment>

    let titleContent = <CreateMemory />;

    if (props.titleContent) titleContent = props.titleContent;

    //If we have a titleID
    if (props.titleID != undefined) titleContent = <React.Fragment>
        <AssignMemory titleID={props.titleID} />
        <SetMemoryPenalty titleID={props.titleID} memories={checkValues} />
        <SetMemoryWrite titleID={props.titleID} memories={checkValues} />
        <UnassignMemory memoryIDs={checkValues} titleID={props.titleID} className={(checkValues.length > 0 ? "" : "button--disabled")} />
    </React.Fragment>

    //If we have a projectID
    if (props.projectID != undefined) titleContent = <React.Fragment>
        <AssignMemory projectID={props.projectID} />
        <SetMemoryPenalty projectID={props.projectID} memories={checkValues} />
        <SetMemoryWrite projectID={props.projectID} memories={checkValues} />
        <UnassignMemory memoryIDs={checkValues} projectID={props.projectID} className={(checkValues.length > 0 ? "" : "button--disabled")} />
    </React.Fragment>

    return (
        <Table checkbox={true} newCheckValues={setCheckValues} getCheckValue={row => row.ID} title="Memories" titleContent={titleContent} renderRow={renderRow} rows={props.rows} cols={[
            { name: "id", sortCol: "ID" },
            { name: "name", sortCol: "name" },
            { name: "note", sortCol: "note" },
            { name: "source lang", sortCol: "sourceLang" },
            { name: "penalty", sortCol: "penalty", hidden: hidePenalty },
            { name: "write", sortCol: "write", hidden: hideWrite }
        ]} />
    )
}

export default Memories;